<script>

export default {
  name: 'NonDynamicTransportContractTable',
  props: {
    transportId: {
      type: Number,
      default: null,
    },
    contracts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'Name', align: 'left', sortable: false, value: 'name' },
        { text: 'Link', sortable: false, value: 'link' },
        { text: 'Created at', value: 'createdAt' },
        { text: 'Download', value: 'download' },
      ],
    };
  },
  methods: {
    download(url, fileName) {
      fetch(url).then(t => t.blob().then((b) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', fileName);
        a.click();
      },
      ));
    },
  },
};
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="contracts"
    hide-actions
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td>{{ props.item.nameOriginal }}</td>
      <td><a :href="props.item.original" target="_blank">{{ props.item.original }}</a></td>
      <td>{{ props.item.createdAt }}</td>
      <td>
        <v-btn
          flat
          icon
          color="blue lighten-2"
          disabled
          @click.prevent="download(props.item.original, props.item.nameOriginal)"
        >
          <v-icon>get_app</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportContractTable.vue